<template>
  <ViewContainer :title="$t('notifications.notification_other')">
    <div class="d-flex justify-center">
      <v-card elevation="2" max-width="850px">
        <div class="d-flex justify-end pt-4 px-6">
          <Button
            plain
            color="primary"
            :disabled="!hasUnReadNotifications"
            :text="$t('notifications.mark_all_as_read')"
            @click="markAllNotificationsAsRead"
          />
        </div>
        <NotificationsListContainer
          class="ma-4"
          :notifications="notifications"
          @showReportsDrawer="handleOpenReportsDrawer"
        />
      </v-card>
    </div>
    <ReportsDrawer
      v-if="isReportsDrawerOpen"
      :visible="isReportsDrawerOpen"
      :organizationId="organizationId"
      :reportId="reportId"
      @close="isReportsDrawerOpen = false"
    />
  </ViewContainer>
</template>

<script>
import mixin from '@/mixins/mixin.vue'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

import { mapActions, mapGetters } from 'vuex'

import ViewContainer from '@/components/Core/Layout/ViewContainer.vue'

import NotificationsListContainer from '@/components/Notifications/NotificationsListContainer.vue'
import Button from '@/components/UI/Button.vue'
import ReportsDrawer from '@/components/ReportsDrawer/ReportsDrawer.vue'

const NOTIFICATIONS_LIMIT = 75

export default {
  components: {
    ViewContainer,
    NotificationsListContainer,
    Button,
    ReportsDrawer,
  },
  data() {
    return {
      isReportsDrawerOpen: false,
      reportId: null,
    }
  },

  computed: {
    ...mapGetters([
      'notifications',
      'hasUnReadNotifications',
      'organizationId',
    ]),
  },

  mixins: [mixin, trackerMixin],

  created() {
    this.pollNotifications({
      localStorage: window.localStorage,
      limit: NOTIFICATIONS_LIMIT,
    }).catch(error => {
      console.log(error)
    })
  },

  methods: {
    ...mapActions(['pollNotifications', 'markAllNotificationsAsRead']),

    handleOpenReportsDrawer(reportId) {
      this.reportId = reportId
      this.isReportsDrawerOpen = true
      this.trackOpenReportList({ source: 'allNotifications' })
    },
  },
}
</script>
